import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Md5 } from 'ts-md5';

import { environment } from '../../../../environments/environment';
import { UserService } from '../../user/user.service';

const API_URL = environment.apiUrl + '/Auth';

@Injectable()
export class AuthService {
  constructor(private http: HttpClient, private userService: UserService) {}

  authenticate(login: any) {
    return this.http
      .post(API_URL + '/login', login, { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userService.setToken(authToken);
        })
      );
  }

  changePassword(body: any) {
    body.confirmNewPassword = Md5.hashStr(body.retypedPassword).toString();
    body.newPassword = Md5.hashStr(body.newPassword).toString();
    body.currentPassword = Md5.hashStr(body.oldPassword).toString();

    delete body.retypedPassword;
    delete body.oldPassword;

    return this.http.post(API_URL + '/change-password', body);
  }

  forgotPassword(body: any) {
    return this.http.post(API_URL + '/resetting-password-request', body);
  }

  forgotPasswordVerifyToken(token: string) {
    return this.http.get(
      API_URL + '/resetting-password-verify-token/' + token,
      {}
    );
  }

  forgotPasswordReset(body: any) {
    return this.http.post(API_URL + '/resetting-password-reset', body);
  }

  refreshToken() {
    return this.http
      .get(API_URL + '/refresh-token', { observe: 'response' })
      .pipe(
        tap((res: any) => {
          const authToken = res.body.token;
          this.userService.setToken(authToken);
        })
      );
  }

  register(body: any) {
    body.password = Md5.hashStr(body.password).toString();
    delete body.retypedPassword;

    return this.http.post(API_URL + '/create', body);
  }

  searchCompanyByCnpj(cnpj: string) {
    // Remove formatação do CNPJ
    const cleanCnpj = cnpj.replace(/[^\d]/g, '');
    return this.http.get<any>(`${API_URL}/company-name`, {params: {cnpj: cleanCnpj}});
  }
}
